import React, { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Typography,
  AppBar,
  Tabs,
  Tab,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import PolicyInfo from "./PolicyInfo";
import Task from "./Task";
import Communication from "./Communication";
import Activity from "./Activity";
import PoliciesList from "../../notes/PoliciesList";
import Attachments from "../../attachments/Attachments";
import { useDispatch, useSelector } from "react-redux";
import { managepolicyallAction } from '../../../redux/actions/dashboardAction';

const PolicyDetails = ({ showPolicyDetails: propShowPolicyDetails, policyId, selectedId, isRowClicked, selectedPolicyDetail }) => {
  const location = useLocation();
  const { state } = location || {};
  const routerPolicyData = state?.policyData;
  const routerShowPolicyDetails = state?.showPolicyDetails;

  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const [defaultPolicy, setDefaultPolicy] = React.useState({});
  const policyListingData =
    useSelector((state) => state.dashboardData.manage_policy_all.content) || [];
  const methods = useForm();

  const effectiveShowPolicyDetails = routerShowPolicyDetails || propShowPolicyDetails;

  useEffect(() => {
    if (effectiveShowPolicyDetails) {
      // If we have router data, use that, otherwise use props data
      if (routerPolicyData) {
        setDefaultPolicy(routerPolicyData);
      } else if (selectedPolicyDetail && selectedPolicyDetail.length > 0) {
        setDefaultPolicy(selectedPolicyDetail[0]);
      } else {
        setDefaultPolicy({});
      }
    }
  }, [selectedPolicyDetail, effectiveShowPolicyDetails, routerPolicyData]);

  useEffect(() => {
    if (effectiveShowPolicyDetails) {
      dispatch(managepolicyallAction());
    }
  }, [dispatch, effectiveShowPolicyDetails]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (!effectiveShowPolicyDetails) {
    return null;
  }

  const policyData = routerPolicyData || defaultPolicy;
  const effectivePolicyId = policyData?.id || policyId;

  const jsonData = {
    policyNumber: policyData?.policyNumber || policyListingData[0]?.policyNumber,
    policyType: policyData?.policyType || policyListingData[0]?.policyType,
    name: policyData?.firstName && policyData?.lastName
      ? `${policyData.firstName} ${policyData.lastName}`
      : policyData?.name || policyListingData[0]?.name,
    companyName: policyData?.company || policyListingData[0]?.company,
    email: policyData?.email || policyListingData[0]?.email,
    phone: policyData?.phoneNumber || policyData?.phone || policyListingData[0]?.phone,
    effDate: policyData?.effectiveDate || policyListingData[0]?.effectiveDate,
    expDate: policyData?.expiryDate || policyData?.expirationDate || policyListingData[0]?.expirationDate,
    status: policyData?.status || policyListingData[0]?.status,
    nextActivity: policyData?.nextActivity || policyListingData[0]?.nextActivity,
    policyPremium: policyData?.premium || policyListingData[0]?.premium,
  };

  return (
    <Paper
      elevation={3}
      style={{ fontFamily: '"Poppins", sans-serif' }}
      id="policydetailspaper"
      // sx={{ boxShadow: "none", backgroundColor: "#ffffff"}}
      sx={
        routerShowPolicyDetails
          ? { boxShadow: "none", backgroundColor: "#ffffff", padding: "0 50px" }
          : { boxShadow: "none", backgroundColor: "#ffffff" }
      }
    >
      <Grid container spacing={0} sx={{ display: 'flex', flexDirection: 'row', margin: 0, padding: 0 }}>
        {!isRowClicked && (
          <Grid item xs={12}>
            <TableContainer
              component={Paper}
              id="policydetailstablecontainer"
              sx={{ fontFamily: '"Poppins", sans-serif', boxShadow: "0" }}
            >
              <Table
                id="policydetailstable"
                sx={{
                  fontFamily: '"Poppins", sans-serif',
                  backgroundColor: "#F8F8F8",
                  boxShadow: "none",
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{fontWeight: 'bold'}}>Policy Number</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Policy Type</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Name</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Company Name</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Email</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Phone</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Eff Date</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Exp Date</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Status</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Next Activity</TableCell>
                    <TableCell sx={{fontWeight: 'bold'}}>Policy Premium</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{jsonData.policyNumber || "-"}</TableCell>
                    <TableCell>{jsonData.policyType || "-"}</TableCell>
                    <TableCell>{jsonData.name || "-"}</TableCell>
                    <TableCell>{jsonData.companyName || "-"}</TableCell>
                    <TableCell>{jsonData.email || "-"}</TableCell>
                    <TableCell>{jsonData.phone || "-"}</TableCell>
                    <TableCell>{jsonData.effDate || "-"}</TableCell>
                    <TableCell>{jsonData.expDate || "-"}</TableCell>
                    <TableCell>{jsonData.status || "-"}</TableCell>
                    <TableCell>{jsonData.nextActivity || "-"}</TableCell>
                    <TableCell>{jsonData.policyPremium || "-"}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid> 
        )}
        <Grid item xs={12}>
          <Box className="policy-detail-main-container">
            <AppBar position="static" id="policydetailsappbar">
              <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Policy Details" id="tabpolicydetails" />
                <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Notes" id="tabnotes" />
                <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Task" id="tabtask" />
                <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Communication" id="tabcommunication" />
                <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Policy Documents" id="tabpolicydocuments" />
                <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Activity Logs" id="tabactivity" />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0} id="policyinfotabpanel">
              <PolicyInfo policyId={effectivePolicyId} />
            </TabPanel>
            <TabPanel value={value} index={1} id="notestabpanel">
              <FormProvider {...methods}>
                <PoliciesList notesPolicyId={effectivePolicyId} getPolicyNumber={jsonData.policyNumber} />
              </FormProvider>
            </TabPanel>
            <TabPanel value={value} index={2} id="tasktabpanel">
              <Task policyId={effectivePolicyId} getPolicyNumber={jsonData.policyNumber} />
            </TabPanel>
            <TabPanel value={value} index={3} id="communicationtabpanel">
              <Communication id={effectivePolicyId} policyId={jsonData.policyNumber} />
            </TabPanel>
            <TabPanel value={value} index={4} id="attachmentstabpanel">
              <Attachments policynum={jsonData.policyNumber} policId={effectivePolicyId}/>
            </TabPanel>
            <TabPanel value={value} index={5} id="activitytabpanel">
              <Activity policynum={jsonData.policyNumber} id={effectivePolicyId} />
            </TabPanel>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simpletabpanel${index}`}
      aria-labelledby={`simpletab${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default PolicyDetails;